module.exports = __webpack_public_path__ + "static/media/music.f7b261a1.svg";